 <div  *ngIf="!initialLoading; else loading" > 
 

        
           <div class="streams-page"  *ngIf="stream" > 
  
<div class="row">
<div class="col-12">
		<h5 class="mainTitle">{{stream.title}} <nb-icon (click)="openEditInfo()"  style="color: #929292; cursor:pointer;" [icon]="'edit-outline'" pack="eva"></nb-icon></h5>
<div style="display:none"><app-stream-info #infoComponent [stream]="stream"></app-stream-info></div>
</div>

</div>

    <div class="row">

    <div class="col-xs-12 col-md-7" >

        <nb-card>
              
            <nb-card-body>
     <div class="streamVideoWrapper">

        <span class="signalInfoIcon" *ngIf="signalInfo" 
        nbPopoverPlacement="bottom"  nbPopoverTrigger="hover" [nbPopover]="signalInf">
            <nb-icon [icon]="'info-outline'" pack="eva" status="primary"></nb-icon>
          </span>

        <div class="streamVideoControls">


 


                <div *ngIf="hasSignal">
                    <div *ngIf="!streamIsRunning" class="streamVideoPreview">
                        <span class="signalLabel hasSignalLabel">SIGNAL</span>    
			<span title="Розірвати зʼєднання"  (click)="openStopModal(rejectSignalModal)" class="rejectSignal"> <i  style="color: #fff;" class="fa fa-plug"></i></span>
                    </div>
                    <div *ngIf="streamIsRunning" class="streamVideoLive">
                    <div class="live-label">LIVE</div>
                     <div class="viewers">  <span style="margin-left: 5px;">{{viewersQuantity}}</span></div>
                    </div>
                </div>

                <div class="streamVideoPreview" *ngIf="!hasSignal">
                    <span class="signalLabel noHasSignalLabel">NO SIGNAL</span>   
                </div>

        </div>
        <div *ngIf="!hasSignal" [style.background]="stream.coverImage ? 'url('+stream.thumbImage+')' : '#000'" class="videoCover"></div>

        <video-player #video [hasSignal]="hasSignal" [sources]="[{  src: streamSrc, type: 'application/x-mpegURL' }]"></video-player>
    </div>   

    <div class="streamRunningPanel">

	<!---->
 <div    style="display:flex; margin-right:auto; margin-top:auto;  margin-bottom:auto;">
                
		<nb-icon  style="color: #929292;" [icon]="'eye-outline'" pack="eva"></nb-icon> <span style="margin:0px 5px 0px 3px; color: #929292;">{{stream.stat?.visitors || 0}}</span>
 
<a  *ngIf="stream.stat" href="/statistics/{{stream._id}}"  style=" margin-left:10px;"  target="_blank"><nb-icon    [icon]="'pie-chart-outline'" pack="eva"></nb-icon></a>
            </div>

        <div class="streamRunning">
        
        
        
           

            <div class="settingsLinkWrapper" style="display: flex;">
 <a href="javascript:;"  style=" margin-left:10px;" (click)="openSettings()" ><nb-icon    [icon]="'settings-outline'" pack="eva"></nb-icon></a>
           
            </div>

            <div class="settingsLinkWrapper" style="display: flex; margin-left: auto;">
                <a href="javascript:;"  style=" margin-left:10px;" (click)="openInfoModal(streamInfoModal)" ><nb-icon  style="color: rgb(255 170 1);"    [icon]="'alert-triangle-outline'" pack="eva"></nb-icon></a>
                          
                           </div>

            <div style="display: none;" class="streamRecord">
               
               
                <span>Записувати відео:</span>
                <div class="switch">
                    
                    <label>
                      Off
                      <input type="checkbox" #recordCheckBox 
                      (change)="onChangeRecord($event.target)"
                       [attr.disabled]="streamIsRunning === true ? 'true' : null"
                      [attr.checked]="recordVideo  === true ? 'checked' : null" />

                      <span class="lever"></span>
                      On
                    </label>
                  </div>
            </div> 

            <div  *ngIf="hasSignal">
                <button *ngIf="!streamIsRunning" nbButton [status]="readyToStream === false ? 'basic' : 'primary'" [disabled]="streamsControlBtnsLoading ||  readyToStream === false" [nbSpinner]="streamsControlBtnsLoading || readyToStream === false"  (click)="startTranslation()" > 
                <span *ngIf="fsProccessing">Обробка даних</span>
                <span *ngIf="!fsProccessing">Запустити   <span  style="margin-left:3px"  class="hidden-480">трансляцію</span></span>
                
                </button>
              
                <button *ngIf="streamIsRunning"  nbButton status="basic"  [disabled]="streamsControlBtnsLoading ||  readyToStream === false" [nbSpinner]="streamsControlBtnsLoading ||  readyToStream === false"  (click)="openStopModal(stopModal)" >Зупинити</button>
             </div>  

             <div  *ngIf="!hasSignal">
                <button nbButton status="basic"  [nbSpinner]="streamsControlBtnsLoading" [disabled]="true">
                
                  <span *ngIf="fsProccessing">Обробка даних</span>
                <span *ngIf="!fsProccessing">Запустити   <span  style="margin-left:3px"  class="hidden-480">трансляцію</span></span>
              
                </button>
            </div>
         
        </div>


    </div>

</nb-card-body>
</nb-card>
              

    </div>

<div style="position: relative; z-index: 7;"  class="col-xs-12 col-md-5">



<div class="rightPanels" >


            <app-streamer-chat [openSettingsCb]="openSettings" [stream]="stream"></app-streamer-chat>
             <app-stream-donate-control [socket]="socket"  [stream]="stream"></app-stream-donate-control>
             <app-stream-sale-control  [keysComponent]="keysComponent" [stream]="stream"></app-stream-sale-control>

             <app-stream-keys-control #keysComponent [stream]="stream"></app-stream-keys-control>
             
            <app-stream-unlock-form-setting-control [stream]="stream"></app-stream-unlock-form-setting-control>   

		<app-stream-qr-toggle-control [stream]="stream"></app-stream-qr-toggle-control>

</div>


    
    </div> 

    </div>

  
        <div class="row">
        <div class="col-xs-12 col-md-7">
          
           <nb-card>
           <nb-card-body>
 
 
	 <div style="display:flex"> 
 
		<div class="signalModes"> 

		 <span [class.activeMode]="signalMode === 1" (click)="setSignalMode(1)">RTMP</span>
		 <span style="margin-bottom:0"  [class.activeMode]="signalMode === 2" (click)="setSignalMode(2)">HTTP</span>

		 </div> 
		 


			<div class="signalModeContent">
			<div *ngIf="signalMode === 1" class="rtmpMode"> 
				<div class="headerContent">Основний URL</div>
				<div style="display:flex; margin-bottom:8px;" >


					
					<div style="margin-right:10px;"> 
					    <span>rtmp://{{domain.name}}/live</span>
					</div>
					<div  class=" "  style="display:flex; margin-left:auto;">

					    <a  href="javascript:;"  
					    (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
					    ngxClipboard [cbContent]="'rtmp://'+domain.name+'/live'"> <i class="fa fa-copy"></i>
					    </a>
					    
					</div>

				</div>
 
				<div class="headerContent">Резервний URL</div>
				<div style="display:flex; margin-bottom:8px;" >

					<div style="margin-right:10px;"> 
					    <span>rtmp://b.{{domain.name}}/backup</span>
					</div>
					<div  class=" "  style="display:flex; margin-left:auto;">

					    <a  href="javascript:;"  
					    (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
					    ngxClipboard [cbContent]="'rtmp://b.'+domain.name+'/backup'"> <i class="fa fa-copy"></i>
					    </a>
					    
					</div>

				</div>
 
				<div class="headerContent">RTMP ключ</div>
				<div style="display:flex" >

					<div style="margin-right:10px;"> 
					    <span style="min-width:225px"  *ngIf="rtmpKeyVisible">{{stream.streamKey}}-{{stream.secretKey}} </span>
 					    <span style="line-height:20px; min-width:225px" *ngIf="!rtmpKeyVisible">************-************ </span>
					     <span   (click)="rtmpKeyVisible = !rtmpKeyVisible" style="line-height:20px; color:#1595fe; cursor:pointer; margin-left:5px;" ><nb-icon   [icon]="rtmpKeyVisible ? 'eye-outline' : 'eye-off-outline'" pack="eva"></nb-icon></span>

					</div>
					<div class=" " style="display:flex; margin-left:auto; ">

					  
				    <a class="copyLink" href="javascript:;" (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
				    ngxClipboard [cbContent]="stream.streamKey+'-'+stream.secretKey"><i class="fa fa-copy"></i></a>
					</div>
					
				</div>
			</div>

  
				<div *ngIf="signalMode === 2" class="httpMode">


				<div class="linkSignal" style="margin-top: 4px;">
			<div class="linkSignalInputWrapper"><input nbInput [class.inputError]="linkSignalInputError" [disabled]="linkSignalInputDisabled" [(ngModel)]="linkSignalInputValue" fullWidth placeholder="http://URL *m3u8 *.mpd *.mp4" /></div>

			<div  class="linkSignalButtonWrapper" >

 				<button *ngIf="!linkSignalIsRunning" (click)="startLinkSignal()" [disabled]="linkSignalButtonsDisabled || !linkSignalInputValue" nbButton fullWidth status="primary">Захоплення</button>
				<button *ngIf="linkSignalIsRunning" (click)="stopLinkSignal()" [disabled]="linkSignalButtonsDisabled"  nbButton fullWidth status="basic">Стоп</button>
		

			</div>

				</div>



                      </div>
	

			 
 
				 

	 </div>
      
		  
      		 

	 </div>
      
  

             
        </nb-card-body>
           </nb-card> 
      
        </div>
    </div>
	



 <div class="row">
        <div class="col-xs-12 col-md-7">
          
           <nb-card>
           <nb-card-header>
                


		<div style="display:flex;  ">
			<div  style=" margin-right:15px ">Перегляд</div>

			<div style="display:flex; margin-left:auto;  margin-right:10px;">
 				<a target="_blank" style="font-weight: normal;" href="{{domain.protocol}}{{domain.name}}/watch?v={{stream.publicIdentity}}">{{domain.protocol}}{{domain.name}}/watch?v={{stream.publicIdentity}}</a>
 
			</div>
			
				    <a class="copyLink" href="javascript:;" style="margin-left: auto;" (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
				    ngxClipboard [cbContent]="domain.protocol+domain.name+'/watch?v='+stream.publicIdentity"><i class="fa fa-copy"></i></a>
		</div>
           </nb-card-header> 
           </nb-card> 
      
        </div>
    </div>


 


    <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card>
               <nb-card-header>
               

		<div style="display:flex; align-items:center;">
			<div>Ретрансляції</div>

			<div style="display:flex; margin-left:auto">
 				<a href="javascript:;" (click)="openRestreamsSettings()" style="font-weight:normal;">Налаштувати</a>
 
			</div>
		</div>
           </nb-card-header>

                <nb-card-body *ngIf="restreams?.length" >
 			<div class="restreamItem" *ngFor="let restream of  restreams">

                <div class="label">{{getRestreamLabel(restream.url)}}</div>
                
                <div style="margin-left: auto;">
                    <nb-toggle  [disabled]="!hasSignal" (checkedChange)="restreamStatusChanged($event,restream.id)"  [(checked)]="restream.status" status="{{restream.colorType}}"></nb-toggle>

                </div>
			</div>
                </nb-card-body>

            </nb-card>
        </div>
        <div class="col-xs-12 col-md-5"></div>
    </div>
 





    <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card >
                <nb-card-header>
                    <span class="panelToggler"   [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('info')"  (click)="panelVisibility.toggleVisibility('info')" >Інформація</span>
                </nb-card-header>
                <nb-card-body  *ngIf="!panelVisibility.isUnvisible('info')"   [@visibilityPanelAnimation]>
                <app-stream-info   [stream]="stream"></app-stream-info>
                </nb-card-body>

            </nb-card>
        </div>
        <div class="col-xs-12 col-md-5"> </div>
    </div>
  
       


    <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card >
                <nb-card-header>
                    <span class="panelToggler"   [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('streamCountdown')" 
 (click)="panelVisibility.toggleVisibility('streamCountdown')" >Зворотний відлік до початку</span>
                </nb-card-header>
                <nb-card-body  *ngIf="!panelVisibility.isUnvisible('streamCountdown')"   [@visibilityPanelAnimation]>
                <app-stream-countdown [stream]="stream"></app-stream-countdown>
                </nb-card-body>

            </nb-card>
        </div>
        <div class="col-xs-12 col-md-5"></div>
    </div>
  
       


 


 


 <div class="row">
        <div class="col-xs-12 col-md-7">
          
           <nb-card  >
           <nb-card-header>
                <span class="panelToggler"    [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('embed')"  (click)="panelVisibility.toggleVisibility('embed')" >Вбудовування</span>
           </nb-card-header>
           <nb-card-body *ngIf="!panelVisibility.isUnvisible('embed')"   [@visibilityPanelAnimation]>
 
		  <div style="margin-bottom:15px">
			<span>Трансляція. Пряме посилання і код вбудовування:</span><br/>
			  <a class="copyLink" target="_blank" href="{{frameCodeLink}}"  >{{frameCodeLink}}</a>

			<div class="streamPageInfo">{{frameCode}}</div>
			
		<div style="text-align:right;">
                <a class="copyLink"  href="javascript:;"  (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
                ngxClipboard [cbContent]="frameCode">Копіювати код</a>
		</div>
  
		</div>

		  <div>
			<span>Чат. Пряме посилання і код вбудовування:</span><br/>
			  <a class="copyLink" target="_blank" href="{{frameChatCodeLink}}"  >{{frameChatCodeLink}}</a>

  			<div  class="streamPageInfo">{{frameChatCode}}</div>
		<div  style="text-align:right;">
                  
                <a class="copyLink"  href="javascript:;"  (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
                ngxClipboard [cbContent]="frameChatCode">Копіювати код</a>
               
                   </div> 
		</div>
 
 
        </nb-card-body>
           </nb-card> 
      
        </div>
    </div>



    <div class="row">
        <div class="col-xs-12 col-md-7">

		<app-stream-download [stream]="stream" [rmhide]="streamsControlBtnsLoading"></app-stream-download>
        </div>
 </div>

   <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card>
          
                <nb-card-body>
		<div style="display:flex; align-items:center;">
			<div>Опублікувати в каналі?</div>

			<div style="display:flex; margin-left:auto">


				   <nb-toggle  
				     labelPosition="left"
				      [(checked)]="publish" 
				      (checkedChange)="togglePublish()" 
				      status="primary">
				      <span *ngIf="publish">Опубліковано</span>
				      <span *ngIf="!publish">Не опубліковано</span>
				    </nb-toggle>


			</div>
		</div>
		 </nb-card-body>
 	   </nb-card>
	</div> 

    </div>	

   
 <div class="row">
        <div class="col-xs-12 col-md-7">
          
           <app-stream-move-from-video (onMoved)="updateDownloadInfo()" [stream]="stream"></app-stream-move-from-video>
      
        </div>
    </div>



   <div class="row">
        <div class="col-xs-12 col-md-7">
	    <nb-card   *ngIf="authService.isAdmin()">
		      
	   <nb-card-header>
		 <span class="panelToggler"   [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('CDN')"  (click)="panelVisibility.toggleVisibility('CDN')" >CDN</span>    
		   </nb-card-header> 
		<nb-card-body  *ngIf="!panelVisibility.isUnvisible('CDN')"   [@visibilityPanelAnimation]>

	    <cdn-control [stream]="stream"></cdn-control>
	</nb-card-body>
	</nb-card>
	</div> 

    </div>	


<div style="min-height:200px;"></div>

    

    </div>
</div>

 


<ng-template #signalInf>
    <div style="padding: 10px;">
        <div>height : {{signalInfo.height}}</div>
        <div>width : {{signalInfo.width}}</div>
        <div>video_codec : {{signalInfo.video_codec}}</div>
	    <div>audio_codec : {{signalInfo.audio_codec}}</div>
        <div>fps : {{signalInfo.fps | number:'1.0-3'}}</div>
    </div>
</ng-template>



<ng-template #loading>
   <app-skeleton-page   [type]="'stream'" ></app-skeleton-page>
<!--
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div> -->
</ng-template> 

     



 <ng-template #stopModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Завершити трансляцію?</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
      <p>Ефір буде завершено, запис зупинено.
Ви дійсно хочете зупинити трансляцію?</p>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="stopTranslation(ref)" nbButton status="danger" >Завершити трансляцію</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасува</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>






 <ng-template #rejectSignalModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Підтвердіть дію</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
      <p>Ви дійсно хочете обірвати вхідний сигнал?</p>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="rejectSignal(ref)" nbButton status="danger" >Так</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Ні</button>

          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>




    <ng-template #streamInfoModal let-data let-ref="dialogRef">

        <nb-card>
          <nb-card-header>
      
            <div style="display:flex; width:100%">
              <span>Найкращі налаштування трансляції для потокового мовлення через LIVESTREAM</span>
              <span style="display:flex; margin-left:auto; cursor: pointer;" (click)="ref.close()">
                <nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
              </span>
            </div>
          </nb-card-header>
          <nb-card-body style="max-height: calc(90vh - 100px); overflow-y: auto;">
            <div>
              <style>
                .infolist li {
                  font-size: 12px !important;
                }
              </style>
              <ol class="infolist">
                <li>
                  <strong>Налаштуйте ваше програмне забезпечення для трансляції</strong>
                  <ul>
                    <li>Використовуйте vMix, OBS Studio, Streamlabs або XSplit для трансляцій.</li>
                    <li>Переконайтеся, що ваше програмне забезпечення оновлено до останньої версії.</li>
                  </ul>
                </li>
                <li>
                  <strong>Оберіть правильний енкодер</strong>
                  <ul>
                    <li>Апаратне кодування (NVENC, QuickSync або AMD) — найкраще для продуктивності.</li>
                    <li>Програмне кодування (x264) — забезпечує кращу якість, але більше навантажує процесор.</li>
                  </ul>
                </li>
                <li>
                  <strong>Виберіть оптимальний бітрейт (залежить від швидкості Інтернету та якості)</strong>
                  <ul>
                    <li>1080p 60fps: 5000–6000 Кбіт/с</li>
                    <li>1080p 30fps: 4500–5000 Кбіт/с</li>
                    <li>720p 60fps: 3500–4500 Кбіт/с</li>
                    <li>720p 30fps: 2500–3500 Кбіт/с</li>
                    <li>Перевірте швидкість вивантаження (наприклад, через speedtest.net) і налаштуйте бітрейт відповідно.</li>
                  </ul>
                </li>
                <li>
                  <strong>Встановіть роздільну здатність та частоту кадрів</strong>
                  <ul>
                    <li>Роздільна здатність: 1920x1080 (Full HD) або 1280x720 (HD)</li>
                    <li>Частота кадрів: 25–30fps для стабільності, 50–60fps для плавності при динамічному контенті.</li>
                  </ul>
                </li>
                <li>
                  <strong>Налаштуйте інтервал ключових кадрів</strong>
                  <ul>
                    <li>Встановіть на 2 секунди.</li>
                  </ul>
                </li>
                <li>
                  <strong>Виберіть правильний протокол трансляції</strong>
                  <ul>
                    <li>Використовуйте RTMP (Real-Time Messaging Protocol) для стабільної трансляції.</li>
                  </ul>
                </li>
                <li>
                  <strong>Налаштуйте бітрейт та частоту дискретизації аудіо</strong>
                  <ul>
                    <li>Бітрейт аудіо: мінімум 128 кбіт/с, рекомендовано 192 кбіт/с.</li>
                    <li>Частота дискретизації: 44,1 кГц або 48 кГц.</li>
                  </ul>
                </li>
                <li>
                  <strong>Оптимізуйте мережеві налаштування</strong>
                  <ul>
                    <li>Використовуйте дротове Ethernet-з'єднання (уникайте Wi-Fi за можливості).</li>
                    <li>Увімкніть динамічний бітрейт (в OBS), щоб уникнути буферизації.</li>
                  </ul>
                </li>
                <li>
                  <strong>Перевірте все перед початком трансляції</strong>
                  <ul>
                    <li>Запустіть приватну тестову трансляцію для перевірки якості та стабільності.</li>
                    <li>Моніторте продуктивність трансляції через Live Preview у LIVESTREAM.</li>
                  </ul>
                </li>
                <li>
                  <strong>Усунення неполадок</strong>
                  <ul>
                    <li>Якщо трансляція працює нестабільно, припиніть трансляцію як у програмному забезпеченні, так і на платформі LIVESTREAM.</li>
                    <li>Перевірте всі налаштування за цим списком і переконайтеся, що все правильно.</li>
                    <li>Видаліть запис і почніть знову.</li>
                  </ul>
                </li>
              </ol>
            </div>
          </nb-card-body>
          <nb-card-footer>
      
            <div style="display:flex; width:100%">
      
              <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="ref.close()" nbButton status="basic">ОК</button>
      
            </div>
          </nb-card-footer>
        </nb-card>
      
      </ng-template>